<template>
  <v-container fluid>
    <div id="content">
      
      <section class="d-flex">
        <BreadCrumb :items="$route.matched"></BreadCrumb>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.stop="addNewWorkTimeGroup" depressed>新しい{{ $route.name }}を作成</v-btn>
      </section>

      <v-card flat>
        <v-data-table
          :headers="tableHeaders"
          :items="desserts"
          :sort-by="['start']"
          :sort-desc="[false]"
          :loading="loading"
          @click:row="onRowClick">
            <template v-slot:item.type="{ item }">
              {{ types.find(e => e.value == item.type).text }}
            </template>
            <template v-slot:item.updatedAt="{ item }">
              {{ getDateTime(item.updatedAt) }}
            </template>
        </v-data-table>
      </v-card>

      <!-- 編集ダイアログ -->
      <v-navigation-drawer v-model="dialog" fixed temporary right stateless width="600" id="dialog" class="edit-dialog">
        <v-card flat class="drawer-card">
          <v-card-title class="dialog-header">
            <span class="title font-weight-light">{{ $route.name }}を{{ this.editedIndex === -1 ? '追加' : '編集' }}</span>
          </v-card-title>
          <v-card-text class="scroll-content">
            <v-form v-model="valid">
              <section class="accordion_inner">
                <v-row no-gutters>
                  <v-col cols="6" class="pa-2">
                    <v-text-field
                      ref="start"
                      type="date"
                      label="開始日付"
                      v-model="editedItem.start"
                      outlined hide-details="auto">
                    </v-text-field>
                  </v-col>
                   <v-col cols="6" class="pa-2">
                    <v-text-field
                      ref="end"
                      type="date"
                      label="終了日付"
                      v-model="editedItem.end"
                      outlined hide-details="auto">
                    </v-text-field>
                  </v-col>
                </v-row>
                <div class="pa-2">
                  <div class="section-title">時間枠</div>
                  <v-data-table
                    :headers="itemHeaders"
                    :items="editedItem.items"
                    :loading="loading"
                    hide-default-footer
                    disable-pagination>
                    <template v-slot:body="{ items }">
                      <tr v-for="(item, index) in items" :key="index">
                        <td class="py-2">
                          <v-row no-gutters>
                            <v-col cols="12" class="pa-2">
                              <v-text-field
                                label="名称"
                                v-model="item.name"
                                :rules="[rules.required]"
                                class="required"
                                outlined hide-details="auto">
                              </v-text-field>
                            </v-col>
                            <v-col cols="4" class="pa-2">
                              <v-text-field
                                type="time"
                                label="開始時刻"
                                v-model="item.start"
                                :rules="[rules.required]"
                                class="required"
                                outlined hide-details="auto">
                              </v-text-field>
                            </v-col>
                            <v-col cols="4" class="pa-2">
                              <v-text-field
                                type="time"
                                label="終了時刻"
                                v-model="item.end"
                                :rules="[rules.required]"
                                class="required"
                                outlined hide-details="auto">
                              </v-text-field>
                            </v-col>
                            <v-col cols="4" class="pa-2">
                              <v-combobox
                                label="区分"
                                v-model="item.type"
                                :items="types"
                                :rules="[rules.required]"
                                class="required"
                                outlined hide-details="auto">
                              </v-combobox>
                            </v-col>
                          </v-row>
                        </td>
                        <td>
                          <span @click="trash(index)">
                            <v-icon small>fas fa-times</v-icon>
                          </span>
                        </td>
                      </tr>
                      <tbody>
                        <tr class="table-footer">
                          <td class="row-ctrl">
                            <v-row no-gutters>
                              <v-col cols="12" md="9" class="pa-2">
                                <v-btn small text @click.stop="addRow">
                                  <v-icon left>far fa-plus-square</v-icon>
                                  時間枠の追加
                                </v-btn>
                              </v-col>
                            </v-row>
                          </td>
                          <td class="row-ctrl"></td>
                        </tr>
                      </tbody>
                    </template>
                  </v-data-table>
                </div>
              </section>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click.stop="save" :loading="saving" :disabled="!valid" text x-large>
              <v-icon left>fas fa-save</v-icon>{{ this.editedIndex === -1 ? '登録' : '更新' }}
            </v-btn>
            <v-btn color="error" @click.stop="remove" :loading="saving" v-if="editedIndex > -1" text x-large>
              <v-icon left>fas fa-trash-alt</v-icon>削除
            </v-btn>
            <v-btn @click="dialog = false" text x-large>
              <v-icon left>fas fa-times</v-icon>閉じる
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-navigation-drawer>

    </div>
  </v-container>
</template>

<script>
import { API, graphqlOperation } from 'aws-amplify'
import { 
  createWorkTimeGroup, updateWorkTimeGroup, deleteWorkTimeGroup,
  createWorkTime, updateWorkTime, deleteWorkTime } from '../graphql/mutations'
import { listWorkTimes, listWorkTimeGroups, getWorkTimeGroup } from '../graphql/queries'
import { 
  onCreateWorkTimeGroup, onUpdateWorkTimeGroup, onDeleteWorkTimeGroup } from '../graphql/subscriptions'

export default {
  data() {
    return {
      search: '',
      loading: true,
      tableHeaders: [
        { text: '開始日付', align: 'start', value: 'start' },
        { text: '終了日付', align: 'start', value: 'end' },
        { text: '更新日時', align: 'start', value: 'updatedAt' },
      ],
      itemHeaders: [
        { text: '', align: 'start', value: 'name', sortable: false },
        { text: '', align: 'end', value: '', sortable: false, width: 30 },
      ],
      dialog: false,
      valid: false,
      saving: false,
      desserts: [],
      editedIndex: -1,
      editedItem: {
        items: [],
      },
      origin: [],
      types: [
        { value: 1, text: '休憩' },
        { value: 2, text: '残業' },
        { value: 3, text: '深夜' },
      ],
    }
  },
  prop: {},
  mounted: async function() {
    //一覧 query
    await this.getWorkTimeGroups()
    //作成時 subscription
    await API.graphql(graphqlOperation(onCreateWorkTimeGroup)).subscribe({
      next: (e) => {
        const row = e.value.data.onCreateWorkTimeGroup
        this.desserts.push(row)
      }
    })
    //更新時 subscription
    await API.graphql(graphqlOperation(onUpdateWorkTimeGroup)).subscribe({
      next: (e) => {
        const row = e.value.data.onUpdateWorkTimeGroup
        this.desserts.find(origin => {
          if (origin.id === row.id) {
            origin = Object.assign(origin, row)
          }
        })
      }
    })
    //削除時 subscription
    await API.graphql(graphqlOperation(onDeleteWorkTimeGroup)).subscribe({
      next: (e) => {
        const row = e.value.data.onDeleteWorkTimeGroup
        this.desserts = this.desserts.filter(origin => origin.id !== row.id)
      }
    })
    this.loading = false
  },
  beforeDestroy() {},
  created() {
    if (!this.isAllowed(this.$route.name)) this.$router.push('/')
  },
  computed: {
    form() {
      return {
        id: this.editedItem.id || null,
        start: this.editedItem.start || null,
        end: this.editedItem.end || null,
      }
    },
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
  },
  methods: {
    //初期化
    async init() {

    },
    //新しい労務・休憩時間を追加
    addNewWorkTimeGroup() {
      this.addRow()

      this.dialog = true
    },
    //行追加
    addRow() {
      this.editedItem.items.push({
        start: null,
        end: null,
        name: null,
        type: null,
      })
    },
    //品目の削除
    trash(index) {
      this.editedItem.items.splice(index, 1)
    },
    //行選択
    async onRowClick(params) {
      this.editedIndex = this.desserts.findIndex(e => e.id === params.id)

      const ret = await API.graphql(graphqlOperation(getWorkTimeGroup, { id: params.id }))

      const items = ret.data.getWorkTimeGroup.workTimes.items
      for (const item of items) {
        item.type = this.types.find(e => e.value == item.type)
      }
      //開始時刻順でソート
      items.sort(function(a, b) {
        if (a.start < b.start) return -1
        if (a.start > b.start) return 1
        return 0
      })

      this.origin = [...items]
      this.editedItem = Object.assign({
        items: [...items],
      }, ret.data.getWorkTimeGroup)

      this.dialog = true
    },
    //保存
    async save() {
      try {
        this.saving = true
        const data = this.form

        //編集
        if (data.id) {
          await API.graphql(graphqlOperation(updateWorkTimeGroup, {input: data}))
          this.log({ type: this.$route.name, text: '[' + this.getSpanText(data.start, data.end) + '] を更新しました' })
          this.myAlert(this.getSpanText(data.start, data.end) + ' を更新しました', 'success')

        //新規
        } else {
          delete data.id
          const ret = await API.graphql(graphqlOperation(createWorkTimeGroup, {input: data}))
          this.editedItem.id = ret.data.createWorkTimeGroup.id
          this.log({ type: this.$route.name, text: '[' + this.getSpanText(data.start, data.end) + '] を追加しました' })
          this.myAlert(this.getSpanText(data.start, data.end) + ' を追加しました', 'success')
        }

        //時間枠の保存
        for (const item of this.editedItem.items) {
          const workTime = this.getWorkTime(item)
          if (workTime.id) {
            await API.graphql(graphqlOperation(updateWorkTime, {input: workTime}))

          } else {
            delete workTime.id
            const ret = await API.graphql(graphqlOperation(createWorkTime, {input: workTime}))
            workTime.id = ret.data.createWorkTime.id
          }
        }
        //オリジナルにのみ存在するものは削除
        for (const workTime of this.origin) {
          if (!this.editedItem.items.find(e => e.id === workTime.id)) {
            await API.graphql(graphqlOperation(deleteWorkTime, {
              input: { id: workTime.id }
            }))
          }
        }

        this.dialog = false

      } catch (e) {
        //console.log(e)
        this.myAlert(e)
        this.saving = false
      }
    },
    //削除
    async remove() {
      try {
        if (confirm(this.getSpanText(this.editedItem.start, this.editedItem.end) + ' を削除しますか？')) {
          //削除
          await API.graphql(graphqlOperation(deleteWorkTimeGroup, {
            input: { id: this.editedItem.id }
          }))
          this.log({ type: this.$route.name, text: '[' + this.getSpanText(this.editedItem.start, this.editedItem.end) + '] を削除しました' })
          this.myAlert(this.getSpanText(this.editedItem.start, this.editedItem.end) + ' を削除しました', 'success')
          this.dialog = false
        }

      } catch (error) {
        this.myAlert(error)
      }
    },
    //荷物
    getWorkTime(item) {
      return {
        id: item.id || null,
        groupID: this.editedItem.id,
        start: item.start,
        end: item.end,
        name: item.name,
        type: item.type.value,
      }
    },
    //期間文字列
    getSpanText(start, end) {
      const startTxt = start || ''
      const endTxt = end || ''

      return startTxt + '～' + endTxt
    },
    //ダイアログclose
    close() {
      this.saving = false
      //this.dialog = false
      setTimeout(() => {
        this.resetForm()
        this.editedIndex = -1
        this.editedItem.id = null
        this.editedItem.items = []

      }, 300)
    },
    //フォームreset
    resetForm() {
      Object.keys(this.$refs).forEach(f => {
        if (this.$refs[f] && !!this.$refs[f].reset) this.$refs[f].reset()
      })
    },
    //労務・休憩時間グループの取得
    async getWorkTimeGroups(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listWorkTimeGroups, { limit: 100, nextToken: nextToken }))
      for (const data of query.data.listWorkTimeGroups.items) {
        this.desserts.push(data)
      }
      if (query.data.listWorkTimeGroups.nextToken) this.getWorkTimeGroups(query.data.listWorkTimeGroups.nextToken)
    },
    //労務・休憩時間の取得
    async getWorkTimes(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listWorkTimes, { limit: 100, nextToken: nextToken }))
      for (const data of query.data.listWorkTimes.items) {
        this.desserts.push(data)
      }
      if (query.data.listWorkTimes.nextToken) this.getWorkTimes(query.data.listWorkTimes.nextToken)
    },
  },
}
</script>

<style lang='scss' scoped>
.section-title {
  margin: 10px 0;
  padding: 5px 10px;
  font-weight: bold;
  background: #e1ecf3;
}
tbody {
  tr {
    &:hover {
      background: transparent !important;
    }
    &.ghost {
      opacity: 0.5 !important;
      background: #c8ebfb !important;
    }
    td {
      .handle {
        &:hover {
          cursor: move;
        }
      }
      
    }
  }
}
.table-footer {
  &:first-of-type td {
    border-top: thin solid rgba(0, 0, 0, 0.12);
  }
  &:hover {
    background: #FFF !important;
  }
  td {
    cursor: default !important;
    &.row-ctrl {
      vertical-align: top;
      padding-top: 10px;
      border-bottom: none !important;
    }
  }
}
.item-ctrl {
  text-align: left;
}
</style>
